import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductCustomActions = createAsyncThunk<
    { guid: string; customActions: any },
    { productId: string },
    ThunkConfig<string>
>('actionsSlice/fetchProductCustomActions', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { productId } = arg

    try {
        const { data } = await api.get(
            getUrlWithVersion(`/products/${productId}/custom_actions`)
        )

        return { guid: productId, customActions: data }
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch custom actions')
    }
})
